module.exports = __webpack_public_path__ + "media/img/uploads/logo-usaf-86fa729e6286413efbe5b49b3e396273.png";